import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { format } from "date-fns";

import { CalendarSlot } from "../../../types";
import PatientChip from "../../chips/patient-chip";
import { getCalendarMeetingColor } from "../calendar-status-utils";

interface WeeklyMeetingInfoProps {
	meeting: CalendarSlot;
	patientLabel: string;
	topPercent: number;
	bottomPercent: number;
	leftPercent: number;
	widthPercent: number;
	onSelectMeeting: (meetingId: string) => void;
}

const WeeklyMeetingInfo: React.FC<WeeklyMeetingInfoProps> = ({
	meeting,
	patientLabel,
	topPercent,
	bottomPercent,
	leftPercent,
	widthPercent,
	onSelectMeeting,
}) => {
	const startTime = format(new Date(meeting.startTime), "h:mm a");
	const endTime = format(new Date(meeting.endTime), "h:mm a");

	const cardBackgroundColor = getCalendarMeetingColor(meeting);

	return (
		<Paper
			onClick={() => onSelectMeeting(meeting.meetingId)}
			elevation={0}
			sx={{
				position: "absolute",
				left: `calc(${leftPercent}% + 2px)`,
				width: `calc(${widthPercent}% - 4px)`,
				top: `${topPercent}%`,
				bottom: `${bottomPercent}%`,
				boxSizing: "border-box",
				zIndex: 1,
				p: 0.5,
				borderRadius: 1,
				cursor: "pointer",
				overflow: "hidden",
				backgroundColor: cardBackgroundColor,
				border: "1px solid #ffffff",
				boxShadow: "none",
				"&:hover": {
					boxShadow: "none",
					filter: "brightness(0.98)",
				},
			}}
		>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="stretch"
				sx={{
					position: "absolute",
					inset: "2px 3px",
					zIndex: 2,
				}}
			>
				<Stack justifyContent="space-between" alignItems="flex-start" sx={{ minWidth: 0 }}>
					<Typography sx={{ fontSize: "0.68rem", fontWeight: 700, lineHeight: 1, color: "#FFF" }}>
						{startTime}
					</Typography>
					<Typography
						sx={{
							fontSize: "0.62rem",
							fontWeight: 400,
							lineHeight: 0.95,
							color: "#FFF",
						}}
					>
						{endTime}
					</Typography>
				</Stack>

				<Stack alignItems="flex-end" justifyContent="flex-start" sx={{ minWidth: 0 }}>
					<PatientChip label={patientLabel} size="small" />
				</Stack>
			</Stack>
		</Paper>
	);
};

export default WeeklyMeetingInfo;
